import * as React from "react";
import { Context } from "./_context";
export const BulletGenericIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.75 13h-1.5v-3h1.5v3ZM6 8.75H3v-1.5h3v1.5Zm7 0h-3v-1.5h3v1.5ZM8.75 6h-1.5V3h1.5v3Z", fill: "currentColor" }));
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 18h-2v-4h2v4Zm-3-5H6v-2h4v2Zm8 0h-4v-2h4v2Zm-5-3h-2V6h2v4Z", fill: "currentColor" }));
  return iconset[size];
};
BulletGenericIcon.iconId = "nmJ33g";
